import { defineComponent as _defineComponent } from 'vue'
import { UseCaseContent } from '@/ui/microtrend/use-cases/use-cases.types'
import { computed, ref } from 'vue'
import TmButton from '@/ui/tm-button/tm-button.vue'
import {
    AiGeneratedUseCaseTextContent
} from '@/ui/microtrend/use-cases/ai-generated-use-case/ai-generated-use-case.types'
import AiExplanation from '@/ui/ai-explanation/ai-explanation.vue'
import { AiExplanationTextContent } from '@/ui/ai-explanation/ai-explanation.types'

interface Props {
  aiTranslations: AiGeneratedUseCaseTextContent
  industries: Array<string>
  explain: (industry: string) => Promise<string>,
  save: (content: UseCaseContent) => Promise<void>
  edit: (content: UseCaseContent) => Promise<void>
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ai-generated-use-case',
  props: {
    aiTranslations: null,
    industries: null,
    explain: null,
    save: null,
    edit: null
  },
  setup(__props: any) {

const props = __props as { aiTranslations: AiGeneratedUseCaseTextContent, industries: Array<string>, explain: (industry: string) => Promise<string>, save: (content: UseCaseContent) => Promise<void>, edit: (content: UseCaseContent) => Promise<void> }



const saveInProgress = ref<boolean>(false)

function content (industry: string, explanation: string): UseCaseContent {
    return {
        title: industry,
        text: explanation
    }
}

const aiExplanationTextContent = computed((): AiExplanationTextContent => ({
    textPrefix: props.aiTranslations.textPrefix,
    textPlaceholder: props.aiTranslations.textPlaceholder,
    textPostfix: props.aiTranslations.textPostfix,
    selectHeader: props.aiTranslations.selectHeader
}))

async function handleSave (industry: string, explanation: string): Promise<void> {
    saveInProgress.value = true

    try {
        await props.save(content(industry, explanation))
    } catch (e) {
        console.log('%cSave of AI created use case failed', 'color: red;')
    } finally {
        saveInProgress.value = false
    }
}

async function handleEdit (industry: string, explanation: string): Promise<void> {
    await props.edit(content(industry, explanation))
}

return { __sfc: true,props, saveInProgress, content, aiExplanationTextContent, handleSave, handleEdit, TmButton, AiExplanation }
}

})